import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getFAQs } from "@/api";
import { useLang, localized } from "@/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQPage() {
  const { data = [] } = useQuery({ queryKey: ["faqs"], queryFn: getFAQs });
  const { t, lang } = useLang();
  return (
    <div data-testid="faq-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="eyebrow mb-5">{t("nav.faq")}</p>
        <h1 className="font-serif-hc font-light text-5xl md:text-6xl leading-[1.02] text-[#F5F2EA]">
          {lang === "es" ? "Preguntas frecuentes" : "Frequently asked questions"}
        </h1>

        <Accordion type="single" collapsible className="w-full mt-14">
          {data.map((f, i) => (
            <AccordionItem key={f.id} value={`f-${i}`} className="border-b border-[#1E2B25]" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-[#F5F2EA] hover:text-[#C4A661] py-6 text-lg font-serif-hc">
                {localized(f.question, lang)}
              </AccordionTrigger>
              <AccordionContent className="text-[#A3A095] leading-relaxed pb-6">
                {localized(f.answer, lang)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
